export const stripTags = (val = '') => {
  return val.replace(/<\/?[^>]+(>|$)/g, '')
}
